import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=85c4882a&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=ts"
export * from "./TextField.vue?vue&type=script&lang=ts"
import style0 from "./TextField.vue?vue&type=style&index=0&id=85c4882a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c4882a",
  null
  
)

export default component.exports